import { SERVER_IP } from 'assets/Config';
import { store } from 'redux/store';

export const fetchCustomerImage = async (customerId, token) => {
	if (!customerId) {
		return { data: null, error: new Error('customerId is required') };
	}

	const authToken = token || store.getState()?.loginRedux?.token;

	try {
		const response = await fetch(`${SERVER_IP}api/customers/${customerId}/image`, {
			headers: {
				Authorization: `Bearer ${authToken}`,
			},
		});

		if (!response.ok) {
			return { data: null, error: new Error(`Failed to fetch image (${response.status})`), status: response.status };
		}

		const blob = await response.blob();

		if (!blob || blob.size === 0) {
			return { data: null, error: new Error('Customer image is empty'), status: response.status };
		}

		return { data: URL.createObjectURL(blob), error: null, status: response.status };
	} catch (error) {
		return { data: null, error };
	}
};
